import { useContextSelector } from 'use-context-selector';
import { GraphRendererContext } from './context';
import type { GraphRendererApi } from './types';

export const useGraphRendererApi = (): (() => GraphRendererApi | null) =>
  useContextSelector(GraphRendererContext, (value) => value.getApi);
